import React, { useState } from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { Modal } from 'antd-v4'
import { IBaseLoyaltyTier } from '@getgreenline/homi-shared'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore/index'
import { DeleteModalTransferScreen } from './DeleteModalTranferScreen'
import { DeleteModalConfirmationScreen } from './DeleteModalConfirmationScreen'

import './index.scss'

interface Props {
  isVisible: boolean
  onCloseModal: () => void
  loyaltyTier: IBaseLoyaltyTier
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

export enum DeleteLoyaltySteps {
  TRANSFER = 'transfer',
  CONFIRMATION = 'confirmation',
}

export const DeleteLoyaltyModal: React.FC<Props & InjectedProps> = inject('currentCompanyStore')(
  observer(({ isVisible, onCloseModal, loyaltyTier, currentCompanyStore }) => {
    const [currentStep, setCurrentStep] = useState(
      loyaltyTier.customerCount > 0 ? DeleteLoyaltySteps.TRANSFER : DeleteLoyaltySteps.CONFIRMATION,
    )
    const [transferCustomers, setTransferCustomers] = useState(false)
    const [newLoyaltyTierId, setNewLoyaltyTierId] = useState<number | undefined>(undefined)

    return (
      <Modal
        title={
          <strong
            style={{
              fontSize: 18,
            }}
          >
            Delete Loyalty Tier
          </strong>
        }
        visible={isVisible}
        onCancel={onCloseModal}
        maskClosable={true}
        footer={null}
        width={600}
      >
        {currentStep === DeleteLoyaltySteps.TRANSFER ? (
          <DeleteModalTransferScreen
            loyaltyTier={loyaltyTier}
            setCurrentStep={setCurrentStep}
            newLoyaltyTierId={newLoyaltyTierId}
            setNewLoyaltyTierId={setNewLoyaltyTierId}
            transferCustomers={transferCustomers}
            setTransferCustomers={setTransferCustomers}
          />
        ) : (
          <DeleteModalConfirmationScreen
            onCloseModal={onCloseModal}
            loyaltyTier={loyaltyTier}
            setCurrentStep={setCurrentStep}
            newLoyaltyTierId={newLoyaltyTierId}
          />
        )}
      </Modal>
    )
  }),
)
